require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka.json") })
        }
      }, "path---betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka!./.cache/json/betreuungseinrichtungen-oberwart-rotenturm-an-der-pinka.json
// module id = 1023
// module chunks = 231608221292675